import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addAppInstanceQuery } from '../apis';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { ROUTE_STRING } from 'constants/RouteString';
import queryKeyAppInstance from '../constants/queryKeyAppInstance';

const useAddAppInstance = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { filter } = useSelector((s) => s.appInstance);

  const addAppInstance = useMutation({
    mutationFn: addAppInstanceQuery,
    onSuccess: (result) => {
      const message = result?.data?.Message || 'App instance created successfully';
      toast.success(message);
      queryClient.invalidateQueries([
        queryKeyAppInstance.getList(JSON.stringify(filter ?? {})),
      ]);
      navigate(ROUTE_STRING.APP_INSTANCE.LIST);
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
    },
  });

  return addAppInstance;
};

export default useAddAppInstance;
